export enum reviewTabs {
	PENDING = 1,
	REVIEWED = 2,
}
export enum ReviewStatusEnum {
	Pending = 1,
	Approved = 2,
	Rejected = 3,
}
